import { render, staticRenderFns } from "./recaptcha.vue?vue&type=template&id=dca97a9c&"
import script from "./recaptcha.vue?vue&type=script&lang=js&"
export * from "./recaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/kccp/PROD/kccp-portal-web-internet-dynamic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dca97a9c', component.options)
    } else {
      api.reload('dca97a9c', component.options)
    }
    module.hot.accept("./recaptcha.vue?vue&type=template&id=dca97a9c&", function () {
      api.rerender('dca97a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/captcha/recaptcha.vue"
export default component.exports